import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Flagpole, ~5 m: a white tapered pole on a small concrete base with a truck
// ball on top and a rectangular flag flying along +X near the top. The flag
// carries the "team" recolour slot (muted red default).
const WHITE = "#e8e6e0";
const CONCRETE = "#9a9a94";
const FLAG_DEFAULT = "#b04a3a";

export const flagpole = defineModel({
  id: "flagpole",
  batchId: "modern",
  name: "Flagpole",
  tags: ["modern", "outdoor", "street", "garden", "flag", "civic"],
  summary: "A 5 m white flagpole flying a recolourable team flag.",
  description:
    "A flagpole of the Modern Living kit: a white tapered 5 m pole on a " +
    "small concrete base, a truck ball on top and a 0.9 x 0.55 m flag flying " +
    "along +X near the top. The flag is the \"team\" recolour slot (muted " +
    "red by default) — fill it with any colour at build time.",
  tiles: { w: 1, h: 1 },
  footprint: 2.6,
  parts(): Part[] {
    return [
      // Concrete base.
      {
        geometry: new THREE.CylinderGeometry(0.2, 0.24, 0.14, 10),
        color: CONCRETE,
        position: [0, 0.07, 0],
      },
      // Tapered pole.
      {
        geometry: new THREE.CylinderGeometry(0.028, 0.055, 5.0, 8),
        color: WHITE,
        position: [0, 2.5, 0],
      },
      // Truck ball.
      {
        geometry: new THREE.SphereGeometry(0.06, 8, 6),
        color: WHITE,
        position: [0, 5.05, 0],
      },
      // Flag flying along +X — the "team" recolour slot.
      {
        geometry: new THREE.BoxGeometry(0.9, 0.55, 0.025),
        color: FLAG_DEFAULT,
        slot: "team",
        position: [0.49, 4.62, 0],
      },
    ];
  },
  animations: [],
});
